import { apiService } from "../api"

export interface ResendVerificationResponse {
   success?: boolean
   rateLimited: boolean
   unlocksAt?: string
   cooldownUntil?: string | null
}

export const ResendVerificationApi = {
   resend: () => apiService.post<ResendVerificationResponse>("/api/users/resend-verification"),
   status: () => apiService.get<{ unlocksAt: string | null }>("/api/users/resend-verification"),
}
